import { Component, OnInit, Input, ViewChild, TemplateRef, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { CommonService } from 'src/app/common-methods/services/common.service';
import { SharedService } from 'src/app/common-methods/services/shared.service';
import { ScreeningDocument, ScreeningDetails } from 'src/app/common-methods/models/screening-details';
import { ScreeningService } from 'src/app/common-methods/services/screening.service';
import { User } from 'src/app/common-methods/models/user';
import { MessageService } from 'primeng/api';
import { MatDialog } from '@angular/material';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { NgxImageCompressService } from 'ngx-image-compress';
import { VerificationService } from 'src/app/common-methods/services/verification.service';
import { MasterService } from 'src/app/common-methods/services/master.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDrag } from '@angular/cdk/drag-drop';
import { DomSanitizer } from '@angular/platform-browser';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { base64StringToBlob } from 'blob-util';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

// Keyword matching against the Employer Research question's free-text name - mirrors
// CompanyCheckService.mapToDetail's findByKeyword/findByWholeWordKeyword, extended here to also
// split GST from PAN and Website from Website Domain (which Company Check merges), and to add
// TAN/OLTAS (which Company Check doesn't handle at all).
const RESEARCH_ATTACHMENT_MATCHERS: { [option: string]: (questionName: string) => boolean } = {
  MCA: (q) => q.includes('mca'),
  EPFO: (q) => q.includes('epfo'),
  GST: (q) => q.includes('gst'),
  TAN: (q) => /\btan\b/i.test(q),
  PAN: (q) => /\bpan\b/i.test(q),
  Website: (q) => q.includes('website') && !q.includes('domain'),
  'Website Domain': (q) => q.includes('domain'),
  OLTAS: (q) => q.includes('oltas'),
};
@Component({
  selector: 'app-screening-documents',
  templateUrl: './screening-documents.component.html',
  styleUrls: ['./screening-documents.component.css'],
  animations: [
    trigger('rotatedState', [
      state('reset', style({ transform: 'rotate(0deg)' })),
      state('right', style({ transform: 'rotate(90deg)' })),
      state('down', style({ transform: 'rotate(180deg)' })),
      state('left', style({ transform: 'rotate(270deg)' })),
      state('up', style({ transform: 'rotate(360deg)' })),
      transition('rotated => default', animate('1500ms ease-out')),
      transition('default => rotated', animate('400ms ease-in'))
    ])
  ]
})
export class ScreeningDocumentsComponent implements OnInit {
  size = 0;
  state: string = 'default';
  docdata: any;
  fileUpload: any;
  dir: string;
  url: any;
  fileString;
  imageSource: any;
  downldata: any;
  zoomval: number;
  rvalue: number;
  enableUpload: boolean = false;
  @Input() mainForm: FormGroup;
  @Input() formgroupName: string;
  @Input() dupScreeningDoc: ScreeningDocument[] = [];
  @Input() validationFlag: boolean;
  @Input() doctType = [];
  @Input() confirmtype: any;
  @Input() showDocType = false;
  @Input() header = 'Supporting Documents';
  @Input() fileBtn: boolean;
  @Input() responseConfirmationType = [];
  @Input() verificationMode = [];
  @Input() verificationTransBindDet;
  @Input() docHint = '';
  @Input() showDocumentRemove = true;
  @Input() digitalDocument: [];
  @Input() cVflag = false;
  // CV Validation for CTS clients: the document uploaded here is the candidate's resume, which the
  // final report renders on its own. Only the labels and the accepted file types change - the
  // upload itself is the same control every other component uses. Defaults to false so every
  // existing usage of this component is untouched.
  @Input() resumeUpload = false;
  @Input() invitationFlag: boolean;
  model = new ScreeningDetails();
  @Input() frmArray: FormArray;
  documentType = new FormControl();
  responseConfirmation = new FormControl();
  modeofConfirmation = new FormControl();
  researchAttachment = new FormControl();
  researchAttachmentOptions: string[] = ['MCA', 'EPFO', 'TAN', 'PAN', 'GST', 'OLTAS', 'Website', 'Website Domain'];
  researchAttachmentSelected: string[] = [];
  private researchQuestAnswers$: Observable<any[]> | undefined;
  // Tracks, per checked option, which attached fileNames it's responsible for - fileName rather
  // than object references, since the document can live in frmArray without a corresponding entry
  // in dupScreeningDoc/model.document (see syncResearchAttachmentSelection).
  private researchAttachmentDocs: { [option: string]: string[] } = {};
  // Whether the employer's Employer Research answers have any screenshot at all for a given
  // option - options with none stay disabled in the dropdown, since there'd be nothing to attach.
  private researchAttachmentAvailable: { [option: string]: boolean } = {};
  userData = new User();
  // image
  showPreview: boolean;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  @ViewChild('imgDialog', null) imgDialog: TemplateRef<any>;
  @ViewChild('pdfDialog', null) pdfDialog: TemplateRef<any>;
  @ViewChild('imgprDialog', null) imgprDialog: TemplateRef<any>;
  @ViewChild(ImageCropperComponent, null) imageCropper: ImageCropperComponent;
  fileData: Blob;
  action: any;
  srcElementVal: any;
  confirmTypeName: any;
  digitalAddressPVReportList: any;
  addressdocument: any;
  constructor(public common: CommonService, private sanitizer: DomSanitizer, private sharedService: SharedService, public dialog: MatDialog,
    private messageService: MessageService, public screeningService: ScreeningService,
    private imageCompress: NgxImageCompressService, public verification: VerificationService,
    private masterService: MasterService) { }

  ngOnInit() {
    this.userData = JSON.parse(sessionStorage.getItem('user_data'));
    if (this.mainForm) {
      //Added by Megala - For VTS2-2024-CRT-0155
      if (this.header === 'response' || this.header === 'reOpenDoc' || this.header === 'recievedInfo' || this.header === 'sanctionScanner' || this.header === 'Gap Reason Supporting Documents') {
        this.frmArray = this.mainForm.get(this.formgroupName) as FormArray;
      } else {
        this.frmArray = this.mainForm.get(this.formgroupName).get('componentDocument') as FormArray;
      }
      if (!this.frmArray) {
        this.frmArray = this.mainForm.get(this.formgroupName) as FormArray;
      }
    }
  const respId = this.confirmtype && this.confirmtype.controls && this.confirmtype.controls.responseConfirmationId
      ? this.confirmtype.controls.responseConfirmationId.value : null;

    if (this.mainForm.value.modeofVerificationId > 0) {
      this.modeofConfirmation.setValue(this.mainForm.value.modeofVerificationId);
    }
    if (this.mainForm.value.screeningComponentInfo && this.mainForm.value.screeningComponentInfo.notApplicableFlag !== true) {
      this.fileBtn = false;
    }
    if (this.formgroupName != 'document') {
      if (!this.validationFlag) {
        this.mainForm.get(this.formgroupName).get('componentDocument').clearValidators();
      } else {
        if (this.mainForm.get(this.formgroupName).get('componentDocument').value.length == 0) {
          this.mainForm.get(this.formgroupName).get('componentDocument').setErrors({ required: true });
        } else {
          this.mainForm.get(this.formgroupName).get('componentDocument').clearValidators();
        }
      }
    }
    //this.digitalPVReport();
    // if (this.confirmtype && this.confirmtype.controls.responseConfirmationId.value > 0) {
    //   this.responseConfirmation.setValue(this.confirmtype.controls.responseConfirmationId.value);
    // }
    if (this.header === 'response') {
      this.syncResearchAttachmentSelection();
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.validationFlag) {
      if (!this.validationFlag) {
        this.mainForm.get(this.formgroupName).get('componentDocument').clearValidators();
      } else {
        if (this.mainForm.get(this.formgroupName).get('componentDocument').value.length == 0) {
          this.mainForm.get(this.formgroupName).get('componentDocument').setErrors({ required: true });
        } else {
          this.mainForm.get(this.formgroupName).get('componentDocument').clearValidators();
        }
      }
    }
  }
  drop(event: CdkDragDrop<[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }
  allowSameFileUpload(event: any): void {
    if (this.header !== 'response') {
      event.srcElement.value = '';
    }

  }
  isUpload(): boolean {
    let array = this.mainForm.get('screeningComponentInfo.componentDocument').value;
    return array.some(e => e.fileName.includes('Screening Application Form')) || array.some(e => e.fileName.includes('Consent Form'));
  }
  fileInputClicked1(event) {
    event.preventDefault();
    document.getElementById('file-upload').click();
  }
  // digitalPVReport() {
  //   this.verification.digitalAddressCheckPVReport(this.userData).subscribe(res => {
  //     if (res) {
  //       this.digitalAddressPVReportList = res;
  //       if (this.verification.tempData && this.verification.tempData.verificationScreeningDet.screeningCompId > 0) {
  //         this.addressdocument = this.digitalAddressPVReportList.filter(x => x.screeningCompId === this.verification.tempData.verificationScreeningDet.screeningCompId);
  //         if (this.addressdocument.length > 0) {
  //           if (this.addressdocument[0].document.length > 0) {
  //             this.responseConfirmation.setValue(this.verification.tempData.verificationTransBindDet.
  //               receivedConfirmationType.find(x => x.lookUpName === 'Digital Mode').lookUpId);
  //             for (let i = 0; i < this.addressdocument[0].document.length; i++) {
  //               const screenDoc = new ScreeningDocument();
  //               if (this.header === 'response') {
  //                 screenDoc.fileName = this.addressdocument[0].document[i].fileName;
  //                 const receivedConfirmLookupId = this.verificationTransBindDet.receivedConfirmLookupId;
  //                 screenDoc.docTypeId = receivedConfirmLookupId;
  //                 this.documentType.setValue(screenDoc.docTypeId);
  //                 screenDoc.responseConfirmationId = this.verification.tempData.verificationTransBindDet.
  //                   receivedConfirmationType.find(x => x.lookUpName === 'Digital Mode').lookUpId;
  //               }
  //               this.frmArray.push(this.initScreeningDocForm());
  //               this.model.document.push(screenDoc);
  //               this.dupScreeningDoc.push(screenDoc);
  //               this.frmArray.at(this.frmArray.length - 1).patchValue(this.dupScreeningDoc[this.dupScreeningDoc.length - 1]);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   });
  // }
  uploaddoc(event) {
    if (this.showDocType) {
      if (this.documentType.value > 0) {
        this.openUploadDoc(event);
      } else {
        event.srcElement.value = '';
        this.documentType.setErrors(Validators.required);
        this.documentType.markAsTouched();
      }

    } else if (this.header === 'response') {
      if (this.responseConfirmation.value > 0) {
        // this.imageChangedEvent = event;
        if (event.target.files.length > 0) {
          const ext = event.target.files[0].name.split('.').pop();
          if (ext === 'png' || ext === 'jpg' || ext === 'JPG' || ext === 'jpeg' || ext === 'gif' || ext === 'psd' || ext === 'bmp') {
            if (event.target.files[0].size <= 10240000) {
              this.srcElementVal = event.srcElement.value;
              const file = event.target.files[0];
              const reader = new FileReader();
              reader.onloadend = (e) => {
                this.imageChangedEvent = reader.result;
              };
              reader.readAsDataURL(file);
              this.openUploadDoc(event);
              event.srcElement.value = '';
              this.imageChangedEvent = '';
              // const dialogRef = this.dialog.open(this.imgDialog, {
              //   width: '600px',
              //   disableClose: true
              // });

              // dialogRef.afterOpened().subscribe(res => {
              //   if (event.target.files[0].size >= 2024000) {
              //     this.compressImage(event);
              //   } else {
              //     const file = event.target.files[0];
              //     const reader = new FileReader();
              //     reader.onloadend = (e) => {
              //       this.imageChangedEvent = reader.result;
              //     };
              //     reader.readAsDataURL(file);
              //   }
              // });
              // dialogRef.afterClosed().subscribe(resp => {
              //   this.imageChangedEvent = '';
              //   if (this.action === 'crop') {
              //     this.openUploadDoc(event);
              //     event.srcElement.value = '';
              //     this.imageChangedEvent = '';
              //   }
              // });
            } else {
              this.showTopCenter('warn', 'Failure Message',
                'Please upload a valid image file with size less than 5 MB');
            }
          } else {
            this.showTopCenter('warn', 'Failure Message',
              'Please upload a valid file,' + ' Acceptable file Formats : .png, .jpg, .JPG, .jpeg, .gif, .psd, .bmp');
          }
        }
      } else {
        event.srcElement.value = '';
        this.responseConfirmation.setErrors(Validators.required);
        this.responseConfirmation.markAsTouched();
      }
    } else {
      this.documentType.setErrors(null);
      this.documentType.markAsUntouched();
      this.responseConfirmation.setErrors(null);
      this.responseConfirmation.markAsUntouched();
      this.openUploadDoc(event);
    }
  }
  confirmType(e) {
    if (e > 0) {
      this.confirmtype.controls.responseConfirmationId.setValue(e);
      this.confirmTypeName = this.verification.tempData.verificationTransBindDet.receivedConfirmationType.find(x => x.lookUpId === e);
      if (this.confirmTypeName.lookUpName === 'Telephone' || this.confirmTypeName.lookUpName === 'Verbally' || this.confirmTypeName.lookUpName === 'Unable to Verify') {
        const screenDoc = new ScreeningDocument();
        screenDoc.screeningDocId = 0;
        screenDoc.docTypeId = this.verificationTransBindDet.receivedConfirmLookupId;
        screenDoc.screeningDocId = 0;
        screenDoc.docSubTypeId = 0;
        screenDoc.fileName = '';
        screenDoc.document = null;
        screenDoc.responseConfirmationId = e;
        this.frmArray.push(this.initScreeningDocForm());
        this.model.document.push(screenDoc);
        this.dupScreeningDoc.push(screenDoc);
        this.frmArray.at(this.frmArray.length - 1).patchValue(this.dupScreeningDoc[this.dupScreeningDoc.length - 1]);
        this.responseConfirmation.setValue('');
      }
    }
  }
  confirmType1(e) {
    if (e > 0) {
      this.confirmtype.controls.receivedResponseDocument.controls.modeofVerificationId.setValue(e);
      this.confirmTypeName = this.verification.tempData.verificationTransBindDet.verificationMode.find(x => x.lookUpId === e);
    }
  }
  isEmploymentHRComponent(): boolean {
    const responseDocument = this.verification.tempData && this.verification.tempData.responseDocument;
    const componentName = responseDocument && responseDocument.componentName;
    return !!componentName && componentName.toUpperCase() === this.common.EMPLOYMENT_HR;
  }
  // Re-derives which checkboxes should show as checked from the documents already attached
  // (matched by fileName against each option's Employer Research screenshots), read off
  // `frmArray` - the reactive FormArray backing the "Attach Documents" list actually rendered
  // (see getDocVlaue()). Local component state (researchAttachmentSelected/researchAttachmentDocs)
  // doesn't survive this component being torn down and recreated when the user navigates to
  // another step and back; `dupScreeningDoc` doesn't help either, since its parent
  // (supporting-documents.component.ts) never binds/populates it from the real document list -
  // it only ever holds documents pushed into it during the current session. `frmArray`, backed by
  // the top-level verificationForm, is the one source that's both authoritative and already
  // populated by the time this component initializes.
  private syncResearchAttachmentSelection() {
    if (!this.isEmploymentHRComponent() || !this.frmArray) {
      return;
    }
    this.getResearchQuestAnswers().subscribe(rows => {
      const attachedFileNames = new Set((this.frmArray.value || []).map((d: any) => d.fileName));
      const selected: string[] = [];
      this.researchAttachmentDocs = {};
      this.researchAttachmentOptions.forEach(key => {
        const isMatch = RESEARCH_ATTACHMENT_MATCHERS[key];
        const matchedRows = isMatch ? rows.filter(r => isMatch((r.questionName || '').toLowerCase())) : [];
        const allFileNames: string[] = [];
        const matchedFileNames: string[] = [];
        matchedRows.forEach(r => {
          const trans = r.researchDocument && r.researchDocument.researchDocumentTrans;
          (trans || []).forEach((t: any) => {
            if (!t.fileName) {
              return;
            }
            allFileNames.push(t.fileName);
            if (attachedFileNames.has(t.fileName)) {
              matchedFileNames.push(t.fileName);
            }
          });
        });
        this.researchAttachmentAvailable[key] = allFileNames.length > 0;
        if (matchedFileNames.length > 0) {
          selected.push(key);
          this.researchAttachmentDocs[key] = matchedFileNames;
        }
      });
      this.researchAttachmentSelected = selected;
      this.researchAttachment.setValue(selected, { emitEvent: false });
    });
  }
  isResearchOptionAvailable(option: string): boolean {
    return !!this.researchAttachmentAvailable[option];
  }
  // Fetched once per component instance and cached - every checkbox toggle reuses the same
  // Employer Research answers for this candidate's employer instead of re-fetching per option.
  private getResearchQuestAnswers(): Observable<any[]> {
    if (!this.researchQuestAnswers$) {
      const empIns = this.verification.tempData && this.verification.tempData.empInsMasterDet;
      this.researchQuestAnswers$ = this.masterService.getResearchQuestAnswer(
        empIns ? empIns.empFlag : true,
        this.verification.tempData ? this.verification.tempData.screeningCompId : 0,
        empIns ? empIns.id : 0,
        empIns ? empIns.businessCategoryLookupId : 0,
        empIns ? empIns.empInsAddressId : 0
      ).pipe(map(res => res || []), shareReplay(1));
    }
    return this.researchQuestAnswers$;
  }
  onResearchAttachmentChange(selected: string[]) {
    const previous = this.researchAttachmentSelected || [];
    const current = selected || [];
    this.researchAttachmentSelected = current;
    const removed = previous.filter(key => current.indexOf(key) === -1);
    const added = current.filter(key => previous.indexOf(key) === -1);

    removed.forEach(key => this.removeResearchAttachment(key));

    if (added.length === 0) {
      return;
    }
    this.getResearchQuestAnswers().subscribe(rows => {
      added.forEach(key => this.addResearchAttachment(key, rows));
    });
  }
  private addResearchAttachment(key: string, rows: any[]) {
    const isMatch = RESEARCH_ATTACHMENT_MATCHERS[key];
    const matchedRows = isMatch ? rows.filter(r => isMatch((r.questionName || '').toLowerCase())) : [];
    const docs = matchedRows.reduce((all, r) => {
      const trans = r.researchDocument && r.researchDocument.researchDocumentTrans;
      return trans && trans.length ? all.concat(trans) : all;
    }, [] as any[]);

    if (docs.length === 0) {
      this.showTopCenter('warn', 'Failure Message', 'No ' + key + ' screenshot found for this employer.');
      return;
    }
    docs.forEach((doc: any) => {
      if (this.frmArray.value.some((x: any) => x.fileName === doc.fileName && x.responseConfirmationId === this.responseConfirmation.value)) {
        return;
      }
      this.screeningService.downloadEmpResearchDocument(doc.researchDocTransId).subscribe(resp => {
        if (!resp || !resp.document) {
          return;
        }
        const ext = (doc.fileName || '').split('.').pop().toLowerCase();
        const blob = base64StringToBlob(resp.document, 'image/' + ext);
        const file = new File([blob], doc.fileName, { type: blob.type });
        const screenDoc = new ScreeningDocument();
        screenDoc.fileName = doc.fileName;
        screenDoc.document = file;
        screenDoc.filePath = '';
        screenDoc.screeningDocId = 0;
        screenDoc.docTypeId = this.verificationTransBindDet.receivedConfirmLookupId;
        screenDoc.docSubTypeId = 0;
        screenDoc.responseConfirmationId = this.responseConfirmation.value;

        this.frmArray.push(this.initScreeningDocForm());
        this.model.document.push(screenDoc);
        this.dupScreeningDoc.push(screenDoc);
        this.frmArray.at(this.frmArray.length - 1).patchValue(this.dupScreeningDoc[this.dupScreeningDoc.length - 1]);

        (this.researchAttachmentDocs[key] = this.researchAttachmentDocs[key] || []).push(screenDoc.fileName);
      });
    });
  }
  // Removes by fileName from each array independently rather than via the shared-index
  // removeDocument() helper - frmArray, dupScreeningDoc and model.document aren't guaranteed to
  // stay index-aligned once a document exists in frmArray without a matching dupScreeningDoc/
  // model.document entry (see syncResearchAttachmentSelection), so a shared index could remove the
  // wrong item from those two.
  private removeResearchAttachment(key: string) {
    const fileNames = this.researchAttachmentDocs[key] || [];
    fileNames.forEach(fileName => {
      const frmIndex = this.frmArray.value.findIndex((x: any) => x.fileName === fileName);
      if (frmIndex > -1) {
        this.frmArray.removeAt(frmIndex);
      }
      const dupIndex = this.dupScreeningDoc.findIndex((x: any) => x.fileName === fileName);
      if (dupIndex > -1) {
        this.dupScreeningDoc.splice(dupIndex, 1);
      }
      const modelIndex = this.model.document.findIndex((x: any) => x.fileName === fileName);
      if (modelIndex > -1) {
        this.model.document.splice(modelIndex, 1);
      }
    });
    delete this.researchAttachmentDocs[key];
  }
  openUploadDoc(event) {
    this.size = event.target.files[0].size;
    const fileSizeInBytes = this.size;
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // Convert bytes to MB
    const formattedSize = fileSizeInMB.toFixed(2);
    for (let i = 0; i < this.frmArray.length; i++) {
      if (this.frmArray.value[i].document.length != 0) {
        let fSize = this.frmArray.value[i].document.size;
        this.size += fSize;
        if (this.header === 'reOpenDoc' && parseFloat(formattedSize) > 5) {
          this.size = 0;
          this.showTopCenter('warn', 'Failure Message', 'The uploaded file size should be less than 5 MB');
          return;
        }
      }
    }
    if (this.frmArray.length === 0 && this.header === 'reOpenDoc') {
      if (this.header === 'reOpenDoc' && parseFloat(formattedSize) > 5) {
        this.size = 0;
        this.showTopCenter('warn', 'Failure Message', 'The uploaded file size should be less than 5 MB');
        return;
      }
    }    
  // this.size = this.size + event.target.files[0].size;
    const fileSize = this.fileSizeValidation(this.size);
    if (!fileSize) {
      this.size = 0;
      this.showTopCenter('warn', 'Failure Message', this.header === 'reOpenDoc' ? 'the overall file size should be less than 150 MB' : 'the overall file size should be less than 5 MB');
      return;
    }
    else {
      let i = 0;
      for (i; i < event.target.files.length; i++) {
        const screenDoc = new ScreeningDocument();
        const ext = event.target.files[i].name.split('.').pop().toLowerCase();
        if (this.header === 'response') {
          screenDoc.fileName = event.target.files[i].name;
          screenDoc.document = event.target.files[i];
        } else {
          screenDoc.fileName = event.target.files[i].name;
          screenDoc.document = event.target.files[i];
        }
        screenDoc.filePath = '';
        screenDoc.screeningDocId = 0;
        if (this.header === 'response') {
          const receivedConfirmLookupId = this.verificationTransBindDet.receivedConfirmLookupId;
          screenDoc.docTypeId = receivedConfirmLookupId;
          this.documentType.setValue(screenDoc.docTypeId);
        } else if (this.header === 'recievedInfo') {
          const receivedInfoDocLookupId = this.verificationTransBindDet.receivedInfoDocLookupId;
          screenDoc.docTypeId = receivedInfoDocLookupId;
          this.documentType.setValue(screenDoc.docTypeId);
        } else if (this.header === 'component') {
          const typeId = this.doctType.find(x => x.lookUpName === 'Component Document');
          this.documentType.setValue(typeId.lookUpId);
          screenDoc.docTypeId = typeId.lookUpId;
          this.documentType.setValue(screenDoc.docTypeId);
          //Added by Megala - For VTS2-2024-CRT-0155
        } else if (this.header === 'reOpenDoc') {
          //need to add
          const receivedInfoDocLookupId = this.verificationTransBindDet.reOpenDocLookupId;
          screenDoc.docTypeId = receivedInfoDocLookupId;
          this.documentType.setValue(screenDoc.docTypeId);
        } else if (this.header === 'sanctionScanner') {
          const sanctionScannerDocLookupId = this.verificationTransBindDet.sanctionScannerDocLookupId;
          screenDoc.docTypeId = sanctionScannerDocLookupId;
          this.documentType.setValue(screenDoc.docTypeId);
        } else {
          screenDoc.docTypeId = this.documentType.value;
        }
        screenDoc.docSubTypeId = 0;
        screenDoc.responseConfirmationId = this.header === 'response' ? this.responseConfirmation.value : 0;

        if (this.mainForm) {
          if (!(this.header === 'response' || this.header === 'recievedInfo' || this.header === 'Gap Reason Supporting Documents')) {
            this.frmArray = this.mainForm.get(this.formgroupName).get('componentDocument') as FormArray;
            if (!this.frmArray) {
              this.frmArray = this.mainForm.get(this.formgroupName) as FormArray;
            }
          }
        }

        if (this.header === 'response' || this.header === 'Annexure Upload' || this.header === 'queryDoc') {
          if (ext === 'png' || ext === 'jpg' || ext === 'JPG' || ext === 'jpeg' || ext === 'gif' || ext === 'psd' || ext === 'bmp') {
            if (this.dupScreeningDoc !== undefined) {
              if (this.frmArray.value.some(x => x.fileName === screenDoc.fileName &&
                x.responseConfirmationId === this.responseConfirmation.value)) {
                this.showTopCenter('warn', 'Failure Message', 'File already exists with this name.');
              } else {
                this.frmArray.push(this.initScreeningDocForm());
                this.model.document.push(screenDoc);
                this.dupScreeningDoc.push(screenDoc);
                this.frmArray.at(this.frmArray.length - 1).patchValue(this.dupScreeningDoc[this.dupScreeningDoc.length - 1]);
              }
            } else {
              this.frmArray.push(this.initScreeningDocForm());
              this.model.document.push(screenDoc);
              this.dupScreeningDoc.push(screenDoc);
              this.frmArray.patchValue(this.dupScreeningDoc);
            }
          } else {
            this.showTopCenter('warn', 'Failure Message',
              'Please upload a valid file,' + ' Acceptable file Formats : .png, .jpg, .JPG, .jpeg, .gif, .psd, .bmp');
          }

        } else {
          if (this.userData.applicationId === 3 && this.screeningService.compData.compName.toUpperCase() === this.common.CV_VALIDATION) {
            if (ext === 'pdf' || ext === 'docx' || ext === 'doc') {
              if (this.dupScreeningDoc !== undefined) {
                if (this.frmArray.value.some(x => x.fileName === screenDoc.fileName && x.docTypeId === this.documentType.value)) {
                  this.showTopCenter('warn', 'Failure Message', 'File already exists with this name.');
                } else {
                  this.frmArray.push(this.initScreeningDocForm());
                  this.model.document.push(screenDoc);
                  this.dupScreeningDoc.push(screenDoc);
                  this.frmArray.at(this.frmArray.length - 1).patchValue(this.dupScreeningDoc[this.dupScreeningDoc.length - 1]);
                }
              } else {
                this.frmArray.push(this.initScreeningDocForm());
                this.model.document.push(screenDoc);
                this.dupScreeningDoc.push(screenDoc);
                this.frmArray.patchValue(this.dupScreeningDoc);
              }
            } else {
              this.showTopCenter('warn', 'Failure Message',
                'Please upload a valid file,' + ' Acceptable file Formats : .pdf, .docx, .doc');
            }
          }
          else {
            if (ext === 'eml' || ext === 'pst' || ext === 'txt' || ext === 'pdf' || ext === 'docx' || ext === 'doc'
              || ext === 'xps' || ext === 'xlsx' || ext === 'xls' || ext === 'xlsb' || ext === 'xlsm'
              || ext === 'png' || ext === 'jpg' || ext === 'JPG' || ext === 'jpeg' || ext === 'gif' || ext === 'psd' || ext === 'tiff'
              || ext === 'eps' || ext === 'raw' || ext === 'msg') {
              if (this.dupScreeningDoc !== undefined) {
                if (this.frmArray.value.some(x => x.fileName === screenDoc.fileName && x.docTypeId === this.documentType.value)) {
                  this.showTopCenter('warn', 'Failure Message', 'File already exists with this name.');
                } else {
                  this.frmArray.push(this.initScreeningDocForm());
                  this.model.document.push(screenDoc);
                  this.dupScreeningDoc.push(screenDoc);
                  this.frmArray.at(this.frmArray.length - 1).patchValue(this.dupScreeningDoc[this.dupScreeningDoc.length - 1]);
                }
              } else {
                this.frmArray.push(this.initScreeningDocForm());
                this.model.document.push(screenDoc);
                this.dupScreeningDoc.push(screenDoc);
                this.frmArray.patchValue(this.dupScreeningDoc);
              }
            } else {
              this.showTopCenter('warn', 'Failure Message',
                'Please upload a valid file,' + ' Acceptable file Formats : .eml, .pst, .txt, .pdf, .docx, .doc, .xps' +
                '' + ', .xlsx, .xls, .xlsb, .xlsm , .png, .jpg, .JPG, .jpeg, .gif, .psd, .tiff, .eps, .raw, .msg');
            }
          }

        }
      }
    }
  }
  compressImage(file1) {
    const file = file1.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      this.imageCompress.compressFile(reader.result, -1, 75, 50).then(
        result => {
          this.imageChangedEvent = result;
          // const objectURL = URL.createObjectURL(this.convertDataUrlToBlob(this.imgResultAfterCompress));
          // this.compressedImage = new File([this.convertDataUrlToBlob(this.imgResultAfterCompress)],
          //   file1.target.files[0].name, { type: `image/${'png'}` });
        }
      );
    };
    reader.readAsDataURL(file);

  }

  convertDataUrlToBlob(dataUrl): Blob {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  }
  showTopCenter(level: string, info: string, message: string) {
    this.messageService.add({ severity: level, summary: info, detail: message });
  }
  removeDocument(data, index) {
    // if (data.screeningDocId === 0) {
    this.frmArray.removeAt(index);
    // }
    this.dupScreeningDoc.splice(index, 1);
    this.model.document.splice(index, 1);
    this.verification.recivedDocument = false;
    // Removing via the "x" button bypasses onResearchAttachmentChange, so the For Research
    // Attachment checkboxes would otherwise stay checked for a file that's no longer attached.
    if (this.header === 'response') {
      this.syncResearchAttachmentSelection();
    }
  }
  downloadDoc(data) {
    if (data.screeningDocId > 0) {
      this.screeningService.downloadScreeningDocument(data.screeningDocId).subscribe(resp => {
        this.common.downloadDocument(data.docId, resp.document, resp.fileName);
      });
    } 
    else if(data.cvDocId > 0)
    {
        this.screeningService.downloadCVDocument(data.cvDocId).subscribe(resp => {
        this.common.downloadDocument(data.docId, resp.document, resp.fileName);
      });
    }
    else {
      this.common.saveByteArray(data.fileName, data.document);
    }
  }
  downloadDoc1(event, data) {
    if (data) {
      this.screeningService.downloadDocument(data).subscribe(resp => {
        this.common.downloadDocument(data.docId, resp.document, resp.fileName);
        this.enableUpload = true;
      });
    }
    event.preventDefault();
    //  else {
    //   this.common.saveByteArray(data.fileName, data.document);
    // }

  }
  showNotification(level: string, info: string, message: string) {
    this.sharedService.emitChange({
      severity: level,
      summary: info,
      detail: message
    });
  }
  initScreeningDocForm() {
    return new FormGroup({
      screeningDocId: new FormControl(0),
      cvDocId:new FormControl(0),
      docId: new FormControl(0),
      document: new FormControl([]),
      fileName: new FormControl(''),
      filePath: new FormControl(''),
      docTypeId: new FormControl(0),
      docSubTypeId: new FormControl(0),
      insuffDocTransId: new FormControl(0),
      responseConfirmationId: new FormControl(),
    });
  }

  getDocVlaue(): ScreeningDocument[] {
    return this.frmArray.value;
  }
  getDocTypeName(typeId): string {
    let type: any;
    if (typeId) {
      type = this.doctType.find(f => f.lookUpId === typeId);
    }
    return type ? type.lookUpName : '';
  }
  getResConfName(document): string {
    let resType: any;
    if (document.responseConfirmationId) {
      resType = this.responseConfirmationType.find(f => f.lookUpId === document.responseConfirmationId);
    }
    return resType ? resType.lookUpName : '';
  }
  downloadloa() {
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = 'assets/documents/AuthorizationForm.pdf';
    link.download = 'AuthorizationForm';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.dialog.open(this.imgDialog, {
      width: '400px'
    });
  }
  imageCropped(event: ImageCroppedEvent) {
    //this.croppedImage = event.base64;
    //this.fileData = this.common.convertBase64ToFileObj(this.croppedImage);
  }
  closeDialog(type) {
    if (type === 'close') {
      this.srcElementVal = '';
    }
    // this.showPreview = true;
    this.action = type;
    this.dialog.closeAll();
  }
  rotate(type) {
    switch (type) {
      case 'right':
        this.imageCropper.rotateRight();
        break;
      case 'left':
        this.imageCropper.rotateLeft();
        break;
      case 'flipHorizontal':
        this.imageCropper.flipHorizontal();
        break;
      case 'flipVertical':
        this.imageCropper.flipVertical();
        break;
      default:
        break;
    }
  }
  downloadFile(data, filename, docId) {
    this.verification.getDigitalDocument(docId).subscribe(resp => {
      if (resp.document) {
        const sampleArr = this.base64ToArrayBuffer(resp.document);
        this.saveByteArray(filename, sampleArr);
      } else {
        alert('file does not exists');
      }
    });
  }
  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }
  saveByteArray(filename, byte) {
    const blob = new Blob([byte], { type: 'application/octet-stream' });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else { // for Non-IE (chrome, firefox etc.)
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display:none;');
      const csvUrl = URL.createObjectURL(blob);
      a.href = csvUrl;
      a.download = filename;
      a.click();
      a.remove();
    }
  }
  preview(data) {
    this.pdftool('reset');
    this.rotateimg('reset');
    this.downldata = data;
    const ext = data.fileName.split('.').pop();
    if (ext === 'png' || ext === 'jpg' || ext === 'JPG' || ext === 'gif' || ext === 'jpeg' || ext === 'psd' || ext === 'bmp') {
      if (data.screeningDocId == 0) {
        const blob = new Blob([data.document], { type: 'image/jpeg;base64' });

        // if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
        //   window.navigator.msSaveOrOpenBlob(blob, data.fileName);
        // } else { 
        //   const a = document.createElement('a');
        //   document.body.appendChild(a);
        //   a.setAttribute('style', 'display:none;');
        //   const csvUrl = window.URL.createObjectURL(blob);
        //   this.url = csvUrl;
        const reader = new FileReader();
        reader.onloadend = (e) => {
          this.imageChangedEvent = reader.result;
          this.imageSource = this.sanitizer.bypassSecurityTrustUrl(this.imageChangedEvent)
        };
        reader.readAsDataURL(blob);
        // };
      }
      else if (data.screeningDocId != 0) {
        this.screeningService.downloadScreeningDocument(data.screeningDocId).subscribe(resp => {
          if (resp) {
            this.imageSource = this.sanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + resp.document);
          }
        });
      }
      else if(data.cvDocId != 0)
    {
        this.screeningService.downloadCVDocument(data.cvDocId).subscribe(resp => {
        this.common.downloadDocument(data.docId, resp.document, resp.fileName);
      });
    }
      this.dialog.open(this.imgprDialog, {
        panelClass: 'myClass',
        disableClose: true
      });
    }
    else if (ext == 'pdf' || ext === 'PDF') {
      if (data.screeningDocId == 0) {
        const blob = new Blob([data.document], { type: 'application/octet-stream' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
          window.navigator.msSaveOrOpenBlob(blob, data.fileName);
        } else {
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display:none;');
          const csvUrl = window.URL.createObjectURL(blob);
          this.url = csvUrl;
        };
      }
      else if (data.screeningDocId != 0) {
        this.screeningService.downloadScreeningDocument(data.screeningDocId).subscribe(resp => {
          if (resp) {
            const blob = base64StringToBlob(resp.document, 'application/octet-stream');
            const csvUrl = window.URL.createObjectURL(blob);
            this.url = csvUrl;
          }
        });
      }
      else if(data.cvDocId != 0)
     {
        this.screeningService.downloadCVDocument(data.cvDocId).subscribe(resp => {
        this.common.downloadDocument(data.docId, resp.document, resp.fileName);
      });
     }
      this.dialog.open(this.pdfDialog, {
        panelClass: 'myClass',
        disableClose: true
      });
    }
    else {
      this.downloadDoc(this.downldata);
    }
  }
  pdftool(type) {
    switch (type) {
      case 'right':
        this.rvalue += 90;
        break;
      case 'left':
        this.rvalue -= 90;
        break;
      case 'zoomin':
        this.zoomval += 0.1;
        break;
      case 'zoomout':
        this.zoomval -= 0.1;
        break;
      case 'reset':
        this.zoomval = 1;
        this.rvalue = 0;
        break;
      case 'download':
        this.downloadDoc(this.downldata);
        break;
      default:
        break;

    }
  }
  zoomin() {

    var myImg = document.getElementById("imgpre");
    var currWidth = myImg.clientWidth;
    if (currWidth == 1500) return false;
    else {
      myImg.style.width = (currWidth + 100) + "px";
    }
  }
  fileSizeValidation(size) {
    return this.bytesToSize(size);
  }
  // formatBytes(bytes) {
  //   const decimals = 2
  //   if (bytes == 0)
  //     return 0;
  //   const k = 1024;
  //   const dm = decimals < 0 ? 0 : decimals;
  //   const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  //   const i = Math.floor(Math.log(bytes) / Math.log(k));
  //   const total = Math.round(bytes / Math.pow(1024, i));//`${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  //   if (i === 2) {
  //     return total > 150 ? false : true;
  //   }
  // }
  bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    const total = Math.round(bytes / Math.pow(1024, i));
    if (i === 2 && this.header !== 'reOpenDoc') {
      return total > 5 ? false : true;
    } 
    if (i === 2 && this.header === 'reOpenDoc') {
      return total > 150 ? false : true;
    } 
    else if (i > 2) {
      return false;
    } else {
      return true;
    }
  }
  zoomout() {
    var myImg = document.getElementById("imgpre");
    var currWidth = myImg.clientWidth;

    if (currWidth == 100) return false;
    else {
      myImg.style.width = (currWidth - 100) + "px";
    }
  }
  rotateimg(route) {
    this.dir = route
    this.state = (this.state === 'default' ? 'rotated' : this.dir);
  }
}
